import React from 'react';
import type { V2Guard, V2Route } from '../units/types';

/** 旧 /ads/banner-ab-tests と同じく組織の enable_auto_banner_ab_test */
const guard: V2Guard = { kind: 'feature', feature: 'enable_auto_banner_ab_test' };

/** この担当が新UIで作り直した画面の経路。作り終えたものから足す（足すまでは旧画面が枠の中に出る） */
const routes: V2Route[] = [
  { path: 'ads/banner-ab-tests', Component: React.lazy(() => import('./AbTestListPage')), guard },
  { path: 'ads/banner-ab-tests/:id', Component: React.lazy(() => import('./AbTestResultPage')), guard },
];

export default routes;
